/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Continue_ShoppingInputs */

const en_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue shopping`)
};

const th_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกซื้อสินค้าต่อ`)
};

const ja_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`買い物を続ける`)
};

const fr_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer mes achats`)
};

const es_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir comprando`)
};

const ru_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить покупки`)
};

const zh_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续选购`)
};

const vi_continue_shopping = /** @type {(inputs: Continue_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếp tục mua sắm`)
};

/**
* | output |
* | --- |
* | "Continue shopping" |
*
* @param {Continue_ShoppingInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const continue_shopping = /** @type {((inputs?: Continue_ShoppingInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Continue_ShoppingInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_continue_shopping(inputs)
	if (locale === "ja") return ja_continue_shopping(inputs)
	if (locale === "fr") return fr_continue_shopping(inputs)
	if (locale === "es") return es_continue_shopping(inputs)
	if (locale === "ru") return ru_continue_shopping(inputs)
	if (locale === "zh") return zh_continue_shopping(inputs)
	if (locale === "vi") return vi_continue_shopping(inputs)
	return en_continue_shopping(inputs)
});